import { createSlice } from "@reduxjs/toolkit";
import { driverLogout } from "../../apis/pharmacy/logout";

const initialState = {
    loading: false,
    data: null,
    error: null
}

const driverLogoutSlice = createSlice({
    name: 'driverLogout',
    initialState,

    extraReducers: (builder) => {
        builder.addCase(driverLogout.pending.type, (state) => {
            return {
                ...state,
                loading: true,
                data: null,
                error: null
            }
        })

        builder.addCase(driverLogout.fulfilled.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            }
        })

        builder.addCase(driverLogout.rejected.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload
            }
        })
    }

})

export default driverLogoutSlice.reducer